import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Button } from '@mui/material';
import { FC } from 'react';

import AddressFields from '../AddressFields/AddressFields';

import styles from './AddAddressModal.module.sass';

interface IAddAddressModal {
  onClose: () => void;
  onAddAddressData: () => void;
  onCloseImg: () => void;
}
const AddAddressModal: FC<IAddAddressModal> = ({
  onClose,
  onAddAddressData,
  onCloseImg,
}) => {
  return (
    <div className={styles.address}>
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <div className={styles.wrapper}>
            <div>
              <h2 className={styles.title}>Куда доставить заказ?</h2>

              <AddressFields />
              <div className={styles.btnWrapper}>
                <Button
                  type="button"
                  variant="orange"
                  fullWidth
                  onClick={() => {
                    onClose();
                    onAddAddressData();
                  }}
                >
                  Добавить
                </Button>
              </div>
            </div>
            <CloseRoundedIcon
              onClick={onCloseImg}
              className={styles.modalImg}
              color="disabled"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAddressModal;
